'use client'
import React, { useState, useEffect, useRef } from 'react'
// import { useSession } from 'next-auth/react'
import Image from 'next/image'
import Link from 'next/link'
import { AiOutlineLayout, AiFillHeart, AiOutlineHeart } from "react-icons/ai"
import { BiSolidBed, BiSolidBath } from "react-icons/bi"
import { FaMountain } from "react-icons/fa";
import { MdBeachAccess, MdPlaylistAddCheckCircle } from "react-icons/md";
import { FaWater } from "react-icons/fa";
import { IoMdVideocam } from 'react-icons/io'
import { BiArea, BiSolidArea } from "react-icons/bi";
import { FaBed, FaBath } from "react-icons/fa"
// import { sendLike } from '@services/sendLike'
import CurrencySymbol from '@components/CurrencySymbol'
import { MdVilla } from "react-icons/md";
import { FaBuilding } from "react-icons/fa";
import { IoLocationOutline } from "react-icons/io5";

import tailwindConfig from '@tailwind.config'
import LinkComponent from '@components/LinkComponent'


const LargeProjectCard = ({ project, imageWidth = 300, imageHeight = 200, includeInactive = false, newLimit, isLast, district = undefined, newDevelopment = false, dictionary, lang }) => {
    const style = {
        color: tailwindConfig.theme.extend.colors.secondary,
        height: 90,
        overflow: 'hidden',
        z: 10
    };

    // const [showLikeBtn, setShowLikeBtn] = useState(false)
    // const [isLiked, setIsLiked] = useState(property.isLiked)
    // const { data: session } = useSession()

    const cardRef = useRef();

    // const handleLike = async () => {
    //     const isLike = await sendLike(property.id)
    //     setIsLiked((prevLike) => !prevLike)
    //     property.isLiked = !property.isLiked
    // };

    useEffect(() => {
        if (!cardRef?.current) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (isLast && entry.isIntersecting) {
                newLimit();
                observer.unobserve(entry.target);
            }
        });

        observer.observe(cardRef.current);
    }, [isLast]);

    // useEffect(() => {
    //     if (session !== null) {
    //         setShowLikeBtn(true)
    //     }
    // }, [])

    let location = 'Pattaya'

    switch (lang) {
        case 'en':
            location = 'Pattaya'
            break;
        case 'th':
            location = 'พัทยา'
            break;
        case 'cn':
            location = '芭提雅'
            break;
        case 'ru':
            location = 'Паттайя'
            break;
        default:
            break;
    }

    // const isSmallDevice = window.innerWidth < 768;
    // const isTablet = window.innerWidth < 1024;

    return (
        <div ref={cardRef} className={`relative sm:w-[${imageWidth}px] w-full bg-light border-[1px] shadow-maincolor/20 hover:shadow-maincolor/40 shadow-sm border-gray-200 rounded-xl`}>
            <LinkComponent
                href={`/${newDevelopment ? 'new-developments' : 'projects'}/` + project.slug}
            >
                <div>
                    <div className='relative w-full  aspect-[4/3] rounded-t-xl flex items-center justify-center overflow-hidden'>
                        <Image
                            placeholder="blur"
                            blurDataURL={project.blur}
                            className='object-cover h-full w-full'
                            src={project.cover ? project.cover : '/images/placeholder.jpg'}
                            width={imageWidth}
                            height={imageHeight}
                            alt={project.slug}
                        />
                        {/* {property.isPromotion ? (
                            <div className='absolute top-2 bg-third text-light p-1 rounded-r-md z-10 font-semibold'>{property.promotionTitle}</div>
                        ) : null
                        } */}
                    </div>
                        <div className='p-3'>
                            <div className='font-semibold text-xl line-clamp-1'>
                                <span>{project.name}</span>
                            </div>
                            {project.fromPrice !== undefined && (
                                <div className='text-xl font-semibold text-third'>From <CurrencySymbol />{project.fromPrice}</div>
                            )}
                            {project.category == 'House' ? (
                                <div className='flex flex-row items-center my-2 mr-2'>
                                    <MdVilla
                                        color={tailwindConfig.theme.extend.colors.secondary}
                                    />
                                    <span className='ml-1 text-maincolor'>{dictionary.house}</span>
                                </div>
                            ) : (
                                <div className='flex flex-row items-center my-2 mr-2'>
                                    <FaBuilding
                                        color={tailwindConfig.theme.extend.colors.secondary}
                                    />
                                    <span className='ml-1 text-maincolor'>{dictionary.condo}</span>
                                </div>
                            )}

                            <div className='flex flex-row items-center border-t-[1px] border-t-gray-300 py-1'>
                                <IoLocationOutline 
                                    color={tailwindConfig.theme.extend.colors.mainhover} 
                                />
                                <p className='ml-1 text-mainhover'>{project.districts[0]?.subdistrict}, {project.districts[0]?.location}</p>
                            </div>
                        </div>
                    </div>
            </LinkComponent >
        </div>
    )
}

export default LargeProjectCard